var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "32865462-7504-462C-BC60-3D3823C2C4D2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Green/Close",
    stroke: "#727831",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,-2.23809524 L13,28.2380952",
    id: "Line-4",
    transform: "translate(13.000000, 13.000000) rotate(-45.000000) translate(-13.000000, -13.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7768433,12.7768433 L-1.69934721,12.7768433",
    id: "Line-4",
    transform: "translate(13.538748, 13.538748) rotate(-45.000000) translate(-13.538748, -13.538748) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimes);
export default __webpack_public_path__ + "static/media/times.97b3c9052a11af60a339a3adc45c887a.svg";
export { ForwardRef as ReactComponent };